import {useSelector, useDispatch} from "react-redux";
import {toggleFilterVisible} from "../store/app";
import {selectActiveFiltersCount} from "../store/filters";

const FilterMenuButton = (props) => {
    const dispatch = useDispatch();
    
    const filterCollapsed = useSelector(state => state.app.filterCollapsed);
    const activeFilterCount = useSelector(selectActiveFiltersCount);
    const smallScreen = useSelector(state => state.app.smallScreen);

    return (
        <button 
            className={`menuBtn btn filterBtn ${smallScreen ? "mobileBtn" : ""}`}    
            onClick={(e) => {
                e.preventDefault(); 
                dispatch(toggleFilterVisible());
            }}
        >
            <span>{props.localisedTitle ? props.localisedTitle : "Filter"} {activeFilterCount > 0 ? `(${activeFilterCount})` : ""}</span>
            {!smallScreen ? <div className={`expandSymbol ${filterCollapsed ? "collapsed" : ""} dark`}/> : ""}
        </button>
    )
}

export default FilterMenuButton;